import type { ProjectRole } from "@melo/shared";
import { store } from "./store";

/** Client-side mirrors of the server's rules, used to show only what a person can do. The server still decides. */
export const isAdmin = () => store.me?.role === "admin";
export const roleIn = (spaceId: string): ProjectRole | undefined => (isAdmin() ? "producer" : store.myRoles[spaceId]);
const RANK: Record<ProjectRole, number> = { contractor: 0, member: 1, producer: 2 };
export const can = (spaceId: string, min: ProjectRole) => {
  const r = roleIn(spaceId);
  return r !== undefined && RANK[r] >= RANK[min];
};
export const isContractorIn = (spaceId: string) => roleIn(spaceId) === "contractor";
export const isContractor = () => store.me?.role === "contractor";

export const ROLE_LABEL: Record<string, string> = { admin: "Admin", member: "Member", contractor: "Contractor", producer: "Producer" };
export const ROLE_HINT: Record<string, string> = {
  admin: "Sees and manages everything, including people and projects.",
  member: "An employee. Works in the projects they are added to.",
  contractor: "Commissioned. Sees only work assigned to them and its brief.",
  producer: "Runs this project: its team, types, views and proposals.",
};

/** A contractor may change their own work and anything under it; members may change anything in their projects. */
export function canEditNode(node: { id: string; spaceId: string; parentId: string | null }): boolean {
  if (can(node.spaceId, "member")) return true;
  if (!isContractorIn(node.spaceId)) return false;
  const me = store.me?.id;
  for (let n: typeof node | undefined = node, i = 0; n && i < 50; n = n.parentId ? store.t.nodes.get(n.parentId) : undefined, i++) {
    const full = store.t.nodes.get(n.id);
    if (full?.assignees.some((a) => a.actorId === me)) return true;
  }
  return false;
}
